/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SendMessageIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABMUlEQVR4nN2VO0rFQBSGU4iPTShYCIqFO0gbvDmPXBn/cwMSGwtfWLoL3YW6Cl2AYCWKna9CG+8GFOWCF6JoMoljoQemnO87P3NmJor+VaWpm2TFOQsuU+ltJEkyFlTAmW2y2utwkdotKdadc6NhBOzmSPBSlnBoEakdfRZwScSKnbgoxoOn4JCiqhQcQuSTgj+um8Yi3xTcVjSYGJF8gdQKVuyT2jErnrxEgmsSrEZtarGbTzEbk+K0TpRKb6mxoNPNpwcbSXFWmySD+xYUx/FIJ1ueTwUrpNgjtRNS9L2mS3DHamuVnbLgoPkh44EEu865iUq4KmZI7NkXTIJHL3DT7qkp+L372dqnQlqAh0Vih78Crun+nhRbP3pFv/pwgoHLt5TELkjsisS2g4H/dL0Boe+UmQoWCzAAAAAASUVORK5CYII=)
 */
export const SendMessageIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M6.6 10.02 14 11.4a.6.6 0 0 1 0 1.18L6.6 14l-2.94 5.87a1.48 1.48 0 0 0 1.99 1.98l17.03-8.52a1.48 1.48 0 0 0 0-2.64L5.65 2.16a1.48 1.48 0 0 0-1.99 1.98l2.94 5.88Z"
        className={colorClass}
      />
    </svg>
  );
};
